import SkillItem from "./SkillItem";

export default SkillItem;
